import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const BaseButton = ({
  text,
  onClick,
  clicked,
  disabled,
  className,
  autoFocus,
  focused,
  ...restProps
}) => {
  const extraClasses = className ? className.split(" ") : [];
  return (
    <div
      className={classNames(
        "app-BaseButton",
        {
          "app-BaseButton-normal": clicked !== true,
          "app-BaseButton-clicked": clicked,
          "app-BaseButton-normal-focused": autoFocus || focused,
          "app-BaseButton-disabled": disabled,
        },
        ...extraClasses
      )}
      {...(!disabled && (onClick = { onClick }))}
    >
      {disabled ? (
        <div className="app-BaseButton__btn">
          <span>{text}</span>
        </div>
      ) : (
        <button
          className="app-BaseButton__btn"
          {...restProps}
          autoFocus={autoFocus}
        >
          {text}
          {/* <span>{text}</span> */}
          {/* <span className="app-BaseButton__icon">
          <img src={RightArrowIcon} alt="right arrow" />
        </span> */}
        </button>
      )}
    </div>
  );
};

BaseButton.defaultProps = {
  clicked: false,
  autoFocus: false,
  focused: false,
};

BaseButton.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  clicked: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  focused: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default BaseButton;
